import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {NgxSpinnerService, Size} from 'ngx-spinner';
import {KeycloakHttpInterceptorService} from '@app/core';


@Component({
  selector: 'app-http-spinner',
  templateUrl: './http-spinner.component.html',
  styleUrls: ['./http-spinner.component.css']
})
export class HttpSpinnerComponent implements OnDestroy, OnInit {
  @Input()
  fullScreen: boolean = false;

  @Input()
  type: string = "ball-clip-rotate-multiple";

  @Input()
  size: Size = "default";

  @Input()
  message: string = "Loading";

  @Input()
  spinnerName = "spinner";

  private pendingHttpRequest: Subscription;

  constructor(private keycloakHttpInterceptor: KeycloakHttpInterceptorService,
              private spinner: NgxSpinnerService) {
    KeycloakHttpInterceptorService.pendingRequestsStatusObs.subscribe(hasPendingRequests => {
      if (hasPendingRequests) {
        void this.spinner.show(this.spinnerName);
      } else {
        void this.spinner.hide(this.spinnerName);
      }
    });
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    if (this.pendingHttpRequest) {
      this.pendingHttpRequest.unsubscribe();
    }
  }
}
